module.exports = __webpack_public_path__ + "assets/check_icon.b0d79d26.svg";